<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt">Publisher: AMY BARRETT-DAFFIN</p>
<p class="copy">Creative Director: GAILEN RUNGE</p>
<p class="copy">Acquisitions Editor: ROXANE CERDA</p>
<p class="copy">Managing/Developmental Editor: LIZ ANELOSKI</p>
<p class="copy">Technical Editor: DEBBIE RODGERS</p>
<p class="copy">Cover/Book Designer: APRIL MOSTEK</p>
<p class="copy">Production Coordinator: ZINNIA HEINZMANN</p>
<p class="copy">Production Editor: ALICE MACE NAKANISHI</p>
<p class="copy">Illustrator: AIMEE RAY</p>
<p class="copy">Photo Assistant: KAELEY HAMMOND</p>
<p class="copy">Photography by ESTEFANY GONZALEZ of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copyt">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copy.vue?0c12c478